import { SET_CURRENT_AUTO_PART, REMOVE_CURRENT_AUTO_PART } from '../../types';

const initialState = { partName: '' };

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_CURRENT_AUTO_PART:
            return {
                ...state,
                partName: payload
            };
        case REMOVE_CURRENT_AUTO_PART:
            return {
                ...state,
                partName: ''
            };
        default:
            return state;
    }
}